var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffers1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "url(#pattern0_641_457)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_641_457",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_641_457",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_641_457",
    width: 32,
    height: 32,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAjZJREFUWIXFlU1PE1EUhp9zpxBJBI2gHZK2IbFxJK4Mbl0b40qjJuxN/Af6C1y4k407/wAoKxcu2YMfC4sIUwQLTUXDAhON2pnjghbaUrhTmRvf1dxzc+Z97nlzZ+A/S/xCcBeVm6Bes6iw7UX1R9VqueIaIIPyDPRkGxUQm8wwcMc1gAF9AUQHdoQbIyPBoGuATnmjueCJnw/UzweazV+cdG1oOtZR7DEFaGPtPALpVvTzwTxwBfgj6EMV2UjdOZavtY2lue4AueABwuPUTTukyr3OCHY3PGbYj8GZjGGw6wSgLQZniomKXScAgDLj0hyY36qE5UMBnMfQOOChAF/WP34CXrvyjyWaPRIAcBnD/FYlLNsBMjKNixhaDnYkQG1taQ0HMTTHbwUAXMSwN/5EAI3bkJ6U561LK0DjNtRS8zfaBpBJ0CPAQAredVGe1irLqz0B+IXiOMqp3ZXODg/1TZZKpd8pAAEJIhDMRPNZYTpNc0gwAUV+7sPINb8QxMcxNGLK1fUPb/bfadGZYnGo/5cXAmePY9wiNSaaqK6HbyFBBNthuGNEb5HiTZC67H1drRNoamxs7MSPeOCqIT59HHMvilc2N1fe9QSQzZ4/Z/r7LqvUK7XP4WKvpkf1WyPwcxeuS39mVdFXqFcazQVTvZjb+q0T8PPBIjDeVpToUtJJ2PrtPyModBYk9g7U/rU/wd9Q5tq7+S6xLiS2t/RbATLE91F9CewA743K7Wp1+VtSf1v/X4cA4U2y7s8oAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffers1);
export default __webpack_public_path__ + "static/media/offers1.fab18574da300c576e79951dd6363f53.svg";
export { ForwardRef as ReactComponent };